import React, { FC } from 'react'
import LaneArrowIcon from 'transfix-icons/build/LaneArrowIcon'
import { MapMarker } from 'transfix-ui/components/MapMarker'
import { TrackingTag } from 'transfix-ui/components/TrackingTag'
import { Box } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'
import { STOP_TYPE } from 'types'
import { brandColors, Tag, TAG_SIZE } from 'transfix-ui'

// Skeleton Loading UI for `ShipmentRow` component
const LoadingShipmentRow: FC = () => (
  <Box display='flex' borderTop={1} borderColor={brandColors.coolGray4} py={3} alignItems='center'>
    <Box width='30%' px={3} pt={1}>
      <Box display='flex'>
        <Skeleton width='150px' />
        <Box ml={2}>
          <TrackingTag />
        </Box>
        <Tag size={TAG_SIZE.xsmall} label='・・・' />
      </Box>
      <Box mt={2}>
        <Skeleton width='350px' component='div' variant='rectangular' />
      </Box>
    </Box>
    <Box
      width='70%'
      px={3}
      borderLeft={1}
      borderColor={brandColors.coolGray4}
      display='flex'
      flexDirection='column'>
      <Box display='flex' alignItems='center' mb={4}>
        <Box mr={6}>
          <MapMarker sequence={1} type={STOP_TYPE.pickup} />
        </Box>
        <Box width='100%'>
          <Skeleton variant='rectangular' height='20px' width='50%' component='div' />
        </Box>
      </Box>
      <Box display='flex' alignItems='center'>
        <Box mr={6}>
          <MapMarker sequence={1} type={STOP_TYPE.delivery} />
        </Box>
        <Box width='100%'>
          <Skeleton variant='rectangular' height='20px' width='80%' component='div' />
        </Box>
      </Box>
    </Box>
  </Box>
)

/**
 * Skeleton Loader UI in the shape of LaneGroup
 */
const LoadingLaneGroup: FC = () => (
  <Box>
    <Box
      p={3}
      className='lane-sticky-header'
      display='flex'
      alignItems='center'
      borderTop={1}
      borderColor={brandColors.coolGray4}>
      <Skeleton width={200} />
      <LaneArrowIcon size='large' className='db mh2' />
      <Skeleton width={200} />
    </Box>
    <Box display='flex' flexDirection='column'>
      <LoadingShipmentRow />
      <LoadingShipmentRow />
      <LoadingShipmentRow />
    </Box>
  </Box>
)

export default LoadingLaneGroup
